import './bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';

import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import Ripple from 'primevue/ripple';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';

import Aura from '@primeuix/themes/aura';

import App from './App.vue';
import i18n from './i18n';
import 'primeicons/primeicons.css';
import 'flag-icons/css/flag-icons.min.css';

import router from './router';
import {
  formatDate,
  formatDateOnly,
  formatDateTime,
  formatDateTimeWithSeconds,
  formatTimeOnly,
  formatTimeWithSeconds,
  getUserTimezone,
  now,
  toUserTimezone,
} from './utils/date';
import { formatAmount, formatAmountWithCurrency, formatCurrency, formatNumber, formatPercentage } from './utils/number';
import { route } from './ziggy';

if (import.meta.env.DEV) {
  import('./vite-checker-overlay-loader');
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
});
app.use(ToastService);
app.use(ConfirmationService);
app.use(DialogService);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);

app.config.globalProperties.$t = ((key: string, params?: Record<string, unknown>): string => {
  return i18n.global.t(key, params ?? {}) as string;
}) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

app.config.globalProperties.$formatDate = formatDate;
app.config.globalProperties.$formatDateTime = formatDateTime;
app.config.globalProperties.$formatDateTimeWithSeconds = formatDateTimeWithSeconds;
app.config.globalProperties.$formatDateOnly = formatDateOnly;
app.config.globalProperties.$formatTimeOnly = formatTimeOnly;
app.config.globalProperties.$formatTimeWithSeconds = formatTimeWithSeconds;
app.config.globalProperties.$toUserTimezone = toUserTimezone;
app.config.globalProperties.$now = now;
app.config.globalProperties.$getUserTimezone = getUserTimezone;

app.config.globalProperties.$formatNumber = formatNumber;
app.config.globalProperties.$formatAmount = formatAmount;
app.config.globalProperties.$formatAmountWithCurrency = formatAmountWithCurrency;
app.config.globalProperties.$formatCurrency = formatCurrency;
app.config.globalProperties.$formatPercentage = formatPercentage;

app.config.globalProperties.$ziggy = route;

app.mount('#app');
